/*! @hebcal/hdate v0.22.0, distributed under GPLv2 https://www.gnu.org/licenses/gpl-2.0.txt */
/**
 * Removes niqqud from Hebrew string
 */
function hebrewStripNikkud(str) {
    const a = str.normalize();
    // now strip out niqqud and trope
    return a.replace(/[\u0590-\u05bd]/g, '').replace(/[\u05bf-\u05c7]/g, '');
}

export { hebrewStripNikkud };
//# sourceMappingURL=hebrewStripNikkud.js.map
